'use client';

import { useEffect, useState } from 'react';
import styles from './VideoPlayer.module.scss';

interface AudioToggleButtonProps {
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

export default function AudioToggleButton({ videoRef }: AudioToggleButtonProps) {
  const [isMuted, setIsMuted] = useState(false);

  // Set audio to OFF by default
  useEffect(() => {
    setIsMuted(true);
  }, [videoRef.current?.src]);

  const toggleMute = () => {
    const mute = !isMuted;
    setIsMuted(mute);
    
    if (videoRef.current) {
      videoRef.current.muted = mute;
    }
  };

  return (
    <div className={styles.volumeControl} onClick={toggleMute}>
      <svg 
        width="16" 
        height="16" 
        viewBox="0 0 16 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Volume bars - 3 vertical bars of increasing height */}
        <rect x="2" y="10" width="3" height="3" fill={isMuted ? "gray" : "currentColor"}/>
        <rect x="7" y="7" width="3" height="6" fill={isMuted ? "gray" : "currentColor"}/>
        <rect x="12" y="4" width="3" height="9" fill={isMuted ? "gray" : "currentColor"}/>
      </svg>
      <p>{isMuted ? "OFF" : "ON"}</p>
    </div>
  );
}